import dayjs from "dayjs";
import _ from "lodash";
import { airports } from "../../config/airports";

function transformBusinessTripReqs(input, perDiemData) {
  return {
    businessTripReqs: input.map((item) => {
      const base = {
        name: item.name,
        label: item.label,
        isChecked: item.isChecked,
      };

      if (item.label === "per_diem" && typeof item.selected !== "undefined") {
        base.amount = item.selected;
        base.currency = perDiemData?.currency;
      } else if (
        item.dropdown &&
        item.isChecked &&
        !item.hasMultipleSelection
      ) {
        base.selected = item.selected || "";
        base.selectedArray = [];
      } else if (item.dropdown && item.isChecked && item.hasMultipleSelection) {
        base.selectedArray = item.selected || [];
        base.selected = "";
      }

      return base;
    }),
  };
}

export const getBizTripPayload = (
  tripData,
  tripType,
  userData,
  leaveData,
  passportData,
  perDiemData,
  companyList,
  comment,
  privilegeCard,
  isDomesticTrip,
  costCenterList,
) => {
  console.log(leaveData);

  return {
    membersInfo: [
      {
        empId: userData?.empId,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        dob: userData?.dateOfBirth,
        gender: userData?.gender,
        passportNo: userData?.passportNumber,
        passportExpiry: userData?.passportExpirationDate,
        passportPdf: passportData["SELF"],
        relationshipStatus: "Self",
        ticketEncash: userData?.ticketEncash,
        privilegeClub: privilegeCard,
      },
    ],
    lastWorkingDate: userData?.lstWorkingDate?.toString() || "",
    grade: userData?.grade,
    companyCode: userData?.companyCode,
    companyName: userData?.companyName,
    countryOfCompany: userData?.countryOfCompany,
    departureDate: tripData[0].departureDate.replaceAll("/", "-"),
    returnDate:
      tripType === "One Way"
        ? ""
        : tripType === "Multi City"
          ? tripData[tripData?.length - 1].type === "One Way"
            ? tripData[tripData?.length - 1].departureDate.replaceAll("/", "-")
            : tripData[tripData?.length - 1].returnDate.replaceAll("/", "-")
          : tripData[0].returnDate.replaceAll("/", "-"),
    isBusinessTrip: true,
    travelDetails: tripData.map((item) => {
      return {
        from: item.from,
        to: item.to,
        departureDate: item.departureDate.replaceAll("/", "-"),
        departureTime: item.departureTime,
        flightType: _.camelCase(item.flightType),
        travelType: item.travelClass,
        paymentType: item?.paymentType?.toLowerCase(),
        returnJourney: item?.type === "One Way" ? false : true,
        returnTime: item?.type === "One Way" ? "" : item.returnTime,
        returnDate:
          item?.type === "One Way" ? "" : item.returnDate.replaceAll("/", "-"),
        perferAirline: (item?.preferredAirlines ?? [])
          .filter((pa) => pa.selected) // keep only selected airlines
          .map((pa) => pa.label),
        businessTripReqs: [
          ...transformBusinessTripReqs(item?.businessRequirement, perDiemData)
            .businessTripReqs,
        ],
        costBorneBy: {
          companyName: companyList?.filter(
            (cl) => cl.id === tripData[0]?.costBorneBy,
          )[0]?.name,
          companyCode: tripData[0]?.costBorneBy,
        },
        projectId: tripData[0]?.projectId ?? "",
        costCenter: tripData[0]?.costCenter,
        costCenterName: costCenterList?.filter(
          (cl) => cl.id === tripData[0]?.costCenter,
        )[0]?.name,
      };
    }),
    businessTripType: _.camelCase(tripType),
    leaveDetails: {
      startDate: dayjs(leaveData?.startDate).format("YYYY-MM-DD"),
      endDate: dayjs(leaveData?.endDate)
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
      expectedReturnDate: dayjs(leaveData?.endDate).format("YYYY-MM-DD"),
      comment: leaveData?.comments,
      attachmentId: leaveData?.attachmentId,
      attachmentUrl: leaveData?.attachmentUrl,
      workTerritoryName: userData?.countryOfCompany,
      departmentCode: userData?.departmentCode,
      costCenter: tripData[0]?.costCenter,
      costBorneBy: tripData[0]?.costBorneBy ?? "",
      projectId: tripData[0]?.projectId ?? "",
      perDiemAmount: perDiemData?.totalAllowance
        ? `${perDiemData?.currency} ${perDiemData?.totalAllowance}`
        : "",
    },
    bookingComments: comment,
    isDomesticTrip: isDomesticTrip,
  };
};

export const validateBizTrip = (formData, setError) => {
  let isError = false;
  let departureArray = [];
  // console.log(formData);

  formData.forEach((data, index) => {
    // FROM & TO
    if (!data.from) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], from: "Please select onboarding" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }
    if (!data.to) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], to: "Please select destination" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }
    if (data.from === data.to) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], to: "Destination can't be same as From" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    // DEPARTURE AND RETURN TIME
    if (!data.departureTime) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], time: "Please select departure time" },
        ...prev?.slice(index + 1),
      ]);

      isError = true;
    }
    if (!data.returnTime && data.type === "Round Trip") {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], time: "Please select preferred return time" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    // DEPARTURE AND RETURN DATE
    if (!data.departureDate) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], date: "Please select departure date" },
        ...prev?.slice(index + 1),
      ]);

      isError = true;
    }
    if (!data.returnDate && data.type === "Round Trip") {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], date: "Please select preferred return date" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    let timeIndex = [
      "12:00AM to 6:00AM",
      "6:00AM to 12:00PM",
      "12:00PM to 6:00PM",
      "6:00PM to 12:00AM",
    ];

    const departureTimeIndex = timeIndex.findIndex(
      (time) => time === data.departureTime,
    );

    const returnTimeIndex = timeIndex.findIndex(
      (time) => time === data.returnTime,
    );

    if (
      data.departureDate === data.returnDate &&
      departureTimeIndex !== -1 &&
      returnTimeIndex !== -1 &&
      departureTimeIndex > returnTimeIndex
    ) {
      setError((prev) => [
        ...prev.slice(0, index),
        {
          ...prev[index],
          time: "Return time is before departure time on same date",
        },
        ...prev.slice(index + 1),
      ]);

      isError = true;
    }

    if (
      departureArray.includes(`${data.departureDate}-${data?.departureTime}`)
    ) {
      setError((prev) => [
        ...prev.slice(0, index),
        {
          ...prev[index],
          time: "Departure Time and Date is same for multiple trips",
        },
        ...prev.slice(index + 1),
      ]);
      isError = true;
    } else {
      departureArray.push(`${data.departureDate}-${data?.departureTime}`);
    }

    if (!data.paymentType) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], paymentType: "Please select Payment Type" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    if (!data.travelClass) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], travelClass: "Please select Travel Class" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    //         if (!data.projectId) {
    //   setError((prev) => [
    //     ...prev?.slice(0, index),
    //     { ...prev[index], projectId: "Please select Project ID" },
    //     ...prev?.slice(index + 1),
    //   ]);
    //   isError = true;
    // }

    if (!data.costBorneBy && Number(index) === 0) {
      setError((prev) => [
        ...prev?.slice(0, index),
        {
          ...prev[index],
          costBorneBy: "Please select Travel cost to be borne by Company",
        },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    if (!data.costCenter && Number(index) === 0) {
      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], costCenter: "Please select Cost Center" },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }

    if (data?.businessRequirement?.length > 0) {
      const bizReqErrors = {};
      data?.businessRequirement.forEach((req) => {
        if (req.isChecked) {
          if (req?.dropdown?.length > 0 && !req.selected) {
            bizReqErrors[req.label] = "Please select " + req.name;
            isError = true;
          }
          if (req.label === "per_diem" && !req.selected) {
            bizReqErrors[req.label] =
              "Please select leave details to calculate per diem";
            isError = true;
          }
        }
      });

      setError((prev) => [
        ...prev?.slice(0, index),
        { ...prev[index], businessRequirement: bizReqErrors },
        ...prev?.slice(index + 1),
      ]);
    }
  });

  return isError;
};

export const validatePerdiem = (formData, setError) => {
  // console.log(formData);

  let isError = false;

  const { startDate, endDate } = formData;

  setError({
    startDate: "",
    endDate: "",
    comments: "",
  });

  const isValidDate = (dateStr) => {
    if (!dateStr) return false;
    const date = new Date(dateStr);
    return date instanceof Date && !isNaN(date);
  };

  if (!startDate) {
    setError((prev) => ({
      ...prev,
      startDate: "Start date is required",
    }));
    isError = true;
  } else if (!isValidDate(startDate)) {
    setError((prev) => ({
      ...prev,
      startDate: "Start date is invalid",
    }));
    isError = true;
  }

  if (!endDate) {
    setError((prev) => ({
      ...prev,
      endDate: "End date is required",
    }));
    isError = true;
  } else if (!isValidDate(endDate)) {
    setError((prev) => ({
      ...prev,
      endDate: "End date is invalid",
    }));
    isError = true;
  }

  if (isValidDate(startDate) && isValidDate(endDate)) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
      setError((prev) => ({
        ...prev,
        endDate: "Start date cannot be after end date",
      }));
      isError = true;
    }
  }

  return isError;
};

export const validateLeaveRequest = (formData, setError) => {
  // console.log(formData);

  let isError = false;

  const { startDate, endDate, comments } = formData;

  setError({
    startDate: "",
    endDate: "",
    comments: "",
  });

  const isValidDate = (dateStr) => {
    if (!dateStr) return false;
    const date = new Date(dateStr);
    return date instanceof Date && !isNaN(date);
  };

  if (!startDate) {
    setError((prev) => ({
      ...prev,
      startDate: "Start date is required",
    }));
    isError = true;
  } else if (!isValidDate(startDate)) {
    setError((prev) => ({
      ...prev,
      startDate: "Start date is invalid",
    }));
    isError = true;
  }

  if (!endDate) {
    setError((prev) => ({
      ...prev,
      endDate: "End date is required",
    }));
    isError = true;
  } else if (!isValidDate(endDate)) {
    setError((prev) => ({
      ...prev,
      endDate: "End date is invalid",
    }));
    isError = true;
  }

  if (isValidDate(startDate) && isValidDate(endDate)) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
      setError((prev) => ({
        ...prev,
        endDate: "Start date cannot be after end date",
      }));
      isError = true;
    }
  }

  if (!comments || !comments.trim()) {
    setError((prev) => ({
      ...prev,
      comments: "Enter purpose of travel",
    }));
    isError = true;
  }
  // else if (comments.trim().length < 5) {
  //   setError((prev) => ({
  //     ...prev,
  //     comments: "Comments must be at least 5 characters",
  //   }));
  //   isError = true;
  // }

  return isError;
};

export const validateLeaveWithData = (bizData, applyLeaveData, setError) => {
  let isError = false;

  bizData.forEach((data, index) => {
    let departureDate = dayjs(data?.departureDate);
    let leaveDate = dayjs(applyLeaveData?.startDate);
    if (departureDate?.isAfter(leaveDate)) {
      setError((prev) => [
        ...prev?.slice(0, index),
        {
          ...prev[index],
          date: "Departure date can't be after leave start date",
        },
        ...prev?.slice(index + 1),
      ]);
      isError = true;
    }
  });

  return isError;
};

export const validateMixDomesticInternational = (bizData, profileData) => {
  console.log(bizData);
  console.log(profileData);

  const workingCountry =
    profileData?.address3 && profileData.address3.trim() !== ""
      ? profileData.address3
      : profileData?.workTerritoryName;

  const airportMap = airports.reduce((map, airport) => {
    map[airport.iata_code] = airport.country;
    return map;
  }, {});

  let hasDomestic = false;
  let hasInternational = false;

  const validRequests = bizData.filter((req) => req?.from && req?.to);

  if (validRequests.length === 0) {
    return [false, false];
  }

  for (const req of validRequests) {
    const fromCountry = airportMap[req.from];
    const toCountry = airportMap[req.to];

    if (!fromCountry || !toCountry) {
      continue;
    }

    const isDomestic =
      fromCountry === workingCountry && toCountry === workingCountry;

    if (isDomestic) {
      hasDomestic = true;
    } else {
      hasInternational = true;
    }

    if (hasDomestic && hasInternational) {
      return [true, null];
    }
  }

  if (hasInternational) return [false, false];
  return [false, true];
};
